export default {
    AGUARDANDO: 'Aguardando Resposta',
    RESPONDIDO: 'Respondido',
    RASCUNHO: 'Rascunho (não enviado)'
}
